export enum ContractGroups {
  EnglishAcademy = 'EnglishAcademy',
  Regular = 'Regular',
}
